module.exports = __webpack_public_path__ + "static/img/1.a940705.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/1.png
// module id = Sh4+
// module chunks = 0